export default "__VITE_ASSET__5fbc72b5__"